<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="flex flex-col gap-4">
    <div v-if="isMode('update')" class="flex flex-col bg-base-200 rounded-md p-4">
      <div class="text-xl font-bold"><i class="fa-regular fa-lock pr-1"></i> Client Credentials</div>

      <div class="grid grid-cols-2">
        <label-component label="Client ID" postfix="(client_id)" />
        <div class="text-gray-500 text-sm">{{ client.client_id }}</div>
      </div>

      <div class="grid grid-cols-2 break-all">
        <label-component label="Client Secret" postfix="(client_secret)" />
        <div class="text-gray-500 text-sm">{{ client.client_secret }}</div>
      </div>

      <div class="grid grid-cols-2 break-all">
        <label-component label="Client Type" postfix="(client_type)" />
        <div class="text-gray-500 text-sm">{{ client.client_type.name }}</div>
      </div>
    </div>

    <div class="flex flex-col gap-2 border-2 border-base-200 rounded-md p-4">
      <div class="text-xl font-bold">Allgemein</div>

      <!-- CLIENT TYPE -->
      <div v-if="isMode('register')">

        <div class="grid grid-cols-2 break-all">
          <label-component label="Client Type" postfix="(client_type)" />

          <fieldset class="text-sm">
            <div class="flex flex-row gap-2 items-center">
              <input type="radio" value="public" v-model="client.client_type" checked>
              <label-component label="Single-Page Application" postfix="(public)" />
            </div>

            <div class="flex flex-row gap-2 items-center">
              <input type="radio" value="web" v-model="client.client_type">
              <label-component label="Web Application" postfix="(web)" />
            </div>

            <div class="flex flex-row gap-2 items-center">
              <input type="radio" value="confidential" v-model="client.client_type">
              <label-component label="Server Application" postfix="(confidential)" />
            </div>

            <div class="flex flex-row gap-2 items-center">
              <input type="radio" value="native" v-model="client.client_type">
              <label-component label="Native Application" postfix="(native)" />
            </div>
          </fieldset>
        </div>
      </div>

      <div class="grid grid-cols-2 items-center">
        <label-component label="Name" postfix="(name)" />

        <input-component type="text" placeholder="Name" v-model="client.name"></input-component>
      </div>

      <div class="grid grid-cols-2 break-all">
        <label-component label="Beschreibung" postfix="(description)" />

        <textarea v-model="client.description" class="textarea textarea-bordered text-base-500"
                  placeholder="Beschreibung"></textarea>
      </div>

      <div class="grid grid-cols-2">
        <label-component label="Grant Types" />

        <div class="flex flex-col text-sm">
          <div class="flex flex-row gap-2 items-center">
            <input type="checkbox" class="rounded-md">
            <label>Authorization Code</label>
          </div>

          <div class="flex flex-row gap-2 items-center">
            <input type="checkbox" class="rounded-md">
            <label>Client Credentials</label>
          </div>

          <div class="flex flex-row gap-2 items-center">
            <input type="checkbox" class="rounded-md">
            <label>Refresh-Token</label>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2 border-2 border-base-200 rounded-md p-4">
      <div class="text-xl font-bold">Login</div>

      <div class="grid grid-cols-2 items-center">
        <label-component label="Application url" postfix="(url)" />

        <input-component type="text" placeholder="Application url" v-model="client.url"></input-component>
      </div>

      <div class="grid grid-cols-2 items-center">
        <label-component label="Redirect url" postfix="(redirect_uri)" />

        <input-component type="text" placeholder="Redirect url" v-model="client.redirect_uri"></input-component>
      </div>
    </div>

    <div class="self-end">
      <button-component fa-icon="fa-regular fa-floppy-disk" @click="$emit('save')"></button-component>
    </div>
  </div>
</template>

<script>
import InputComponent from "@/components/InputComponent";
import ButtonComponent from "@/components/ButtonComponent";
import LabelComponent from "@/components/LabelComponent";

export default {
  name: "GeneralTab",
  components: { LabelComponent, ButtonComponent, InputComponent },
  props: ["modelValue", "mode"],
  data() {
    return {
      client: undefined,
      client_types: []
    };
  },
  created() {
    this.client = this.modelValue;
  },
  watch: {
    client: {
      handler() {
        this.$emit("update:modelValue", this.client);
      },
      deep: true
    }
  },
  methods: {
    isMode(mode) {
      return this.mode === mode;
    }
  }
};
</script>

<style scoped>

</style>